import { useEffect } from 'react'

import { useRouter } from 'next/router'

import gridAnalytics from '@/lib/analytics'

export default function Analytics() {
  const router = useRouter()

  useEffect(() => {
    gridAnalytics.page()

    router.events.on('routeChangeComplete', () => gridAnalytics.page())

    return () => {
      router.events.off('routeChangeComplete', () => gridAnalytics.page())
    }
  }, [router.events])

  return null
}
